/** @format */

export const SET_AUTH_LOADING = "SET_AUTH_LOADING";
export const SET_AUTH = "SET_AUTH";
export const GET_USER_PROFILE_LOADING = "GET_USER_PROFILE_LOADING";
export const GET_USER_PROFILE = "GET_USER_PROFILE";
export const GET_USER_PROFILE_FAILED = "GET_USER_PROFILE_FAILED";
export const GET_TOKEN_LOADING = "GET_TOKEN_LOADING";
export const GET_TOKEN_SUCCESS = "GET_TOKEN_SUCCESS";
export const GET_TOKEN_FAIL = "GET_TOKEN_FAIL";
export const GET_LISTING_PAGE_LOADING = "GET_LISTING_PAGE_LOADING";
export const GET_LISTING_PAGE = "GET_LISTING_PAGE";
export const GET_LISTING_PAGE_FAILED = "GET_LISTING_PAGE_FAILED";
export const GET_SELLER_DETAILS = "GET_SELLER_DETAILS";
export const SET_OPEN_REQUEST = "SET_OPEN_REQUEST";
export const SET_SCHEDULE_REQUESTS = "SET_SCHEDULE_REQUESTS";
export const SET_MEETING_COUNT = "SET_MEETING_COUNT";
export const GET_SLP_DETAILS = "GET_SLP_DETAILS";
export const GET_CURRENCY_CONVERSION = "GET_CURRENCY_CONVERSION";
export const GET_CURRENCY_CONVERSION_FORMAT = "GET_CURRENCY_CONVERSION_FORMAT";
export const GET_PRODUCT_DETAILS = "GET_PRODUCT_DETAILS";
export const SET_MY_ADDRESSES = "SET_MY_ADDRESSES";
export const SET_QUOTE_BY_STATUS = "SET_QUOTE_BY_STATUS";
export const SET_ORDER_BY_ID = "SET_ORDER_BY_ID";
export const SET_CART = "SET_CART";
export const GET_MY_ORDERS = "GET_MY_ORDERS";
export const SET_SFL = "SET_SFL";
export const SET_BRAND_NAME = "SET_BRAND_NAME";
export const SET_MY_COLLECTION = "SET_MY_COLLECTION";
export const GET_USER_IP_DETAILS = "GET_USER_IP_DETAILS";
export const SET_ERROR500 = "SET_ERROR500";
export const SET_DROPSHIP_RESERVE = "SET_DROPSHIP_RESERVE";
export const SET_DEVICE_TYPE = "SET_DEVICE_TYPE";
export const SET_DROPSHIP_OFFSET = "SET_DROPSHIP_OFFSET";
export const GET_SEARCH_LISTING_PAGE_LOADING = "GET_SEARCH_LISTING_PAGE_LOADING";
export const GET_SEARCH_LP_DETAILS = "GET_SEARCH_LP_DETAILS";
export const GET_SEARCH_LISTING_PAGE_FAILED = "GET_SEARCH_LISTING_PAGE_FAILED";
export const SET_VIEWED_PRODUCT_DETAILS = "SET_VIEWED_PRODUCT_DETAILS";
export const SET_PAGE_REFRESH = "SET_PAGE_REFRESH"
export const  VIEW_THIS_RFQ_SUCCESS= "VIEW_THIS_RFQ_SUCCESS";
export const VIEW_THIS_RFQ_FAILURE = "VIEW_THIS_RFQ_FAILURE";
export const QALARA_RECOMMENDATION = "QALARA_RECOMMENDATION";
export const SET_CART_PRODUCTS_QUANTITY = "SET_CART_PRODUCTS_QUANTITY";
